import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { countryCodes } from '../utils/countryCodes';
import Select from 'react-select';


import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Box,
  Typography,
  Alert,
  CircularProgress,
  Paper,
  InputAdornment,
  Container,
} from "@mui/material";
import imgUrl from "../assets/images/imgUrl";
import { apiServices } from "../services/apiServices";
import Swal from 'sweetalert2';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    countryCode: "+1",
    mobile: "",
    designation: "",
    email: "",
    subject: "",
    message: "",
  });
  const [countryCode, setCountryCode] = useState('+91');


  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const handleCountryCodeChange = (selectedOption) => {
    const newCountryCode = selectedOption ? selectedOption.code : '+91';
    setCountryCode(newCountryCode);
  };
  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const contactData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        contactNumber: `${countryCode} ${formData.mobile}`,
        query: formData.message,
      };

      console.log("Sending contact data:", contactData);

      const response = await apiServices.postAPI("contact-admin", contactData);
      console.log("Contact API response:", response);

      if (response.status === 200 || response.status === 201) {
        // Show success message with SweetAlert
        Swal.fire({
          title: 'Success!',
          text: 'Email sent successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#214F7D'
        });

        // Clear all form fields after successful submission
        setFormData({
          firstName: "",
          lastName: "",
          countryCode: "+1",
          mobile: "",
          designation: "",
          email: "",
          subject: "",
          message: "",
        });
      }
    } catch (error) {
      console.error("Contact submission failed:", error);
      setAlert({ show: true, type: "error", message: "Failed to send message. Please try again." });
    } finally {
      setLoading(false);
    }
  };
  const nameRegex = /^[A-Za-z\s]*$/;
  // Modern pill-shaped input style matching the image – consistent spacing
  const inputSx = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#FFFFFF",
      borderRadius: "12px",
      "& fieldset": { borderColor: "#E0E0E0" },
      "&:hover fieldset": { borderColor: "#A3D139" },
      "&.Mui-focused fieldset": { borderColor: "#A3D139" },
    },
  };
  return (
    <Box sx={{ bgcolor: "#F4F9F4" }}>
      {/* 1. BANNER SECTION (Preserved) */}
      {/* <Box
        className="contactSectionBg commonBannerBg"
        sx={{ backgroundSize: "cover", backgroundPosition: "center", height: "600px", position: "relative" }}
      >

      </Box> */}

      {/* 2. SPLIT LAYOUT SECTION (Like the image) */}
      <Container maxWidth="lg" sx={{ mt: -10, }}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: "40px",
            overflow: "visible",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            minHeight: "500px",
          }}
        >
          {/* LEFT SIDE: Image/Character Area */}
          <Grid
            item
            md={6}
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
              p: 4,
              position: "relative",
            }}
          >
            {/*character image URL */}
            <Box
              component="img"
              src={imgUrl.leftsideImg}
              sx={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Grid>

          {/* RIGHT SIDE: White Form Card */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              bgcolor: "white",
              p: { xs: 4, md: 8 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              borderRadius: { xs: "40px", md: "0 40px 40px 0" },
            }}
          >
            <Box sx={{ textAlign: "center", mb: 4 }}>
              <Box component="img" src={imgUrl.logo} sx={{ height: 30, mb: 2 }} />
              <Typography variant="h1" sx={{ fontWeight: 800, color: "#2D3436" }}>
                Contact Us
              </Typography>
            </Box>

            {alert.show && <Alert severity={alert.type} sx={{ }}>{alert.message}</Alert>}

            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <Grid container spacing={1.5}>
                {/* First name & last name on one line; combined width matches email row */}
                <Grid item xs={12} sx={{ width: '100%', display: 'block' }}>
                  <Box sx={{ display: 'flex', gap: 2, width: '100%', flexDirection: { xs: 'column', sm: 'row' } }}>
                    <TextField
                      fullWidth
                      label="First Name"
                      variant="outlined"
                      sx={{ ...inputSx, flex: 1, minWidth: 0 }}
                      value={formData.firstName}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (nameRegex.test(value)) {
                          handleInputChange("firstName", value);
                        }
                      }}
                      required
                    />
                    <TextField
                      fullWidth
                      label="Last Name"
                      variant="outlined"
                      sx={{ ...inputSx, flex: 1, minWidth: 0 }}
                      value={formData.lastName}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (nameRegex.test(value)) {
                          handleInputChange("lastName", value);
                        }
                      }}
                      required
                    />
                  </Box>
                </Grid>

                {/* Email - own line, full width */}
                <Grid item xs={12} sx={{ width: '100%', display: 'block' }}>
                  <TextField
                    fullWidth
                    type="email"
                    label="Email Address"
                    sx={inputSx}
                    value={formData.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    required
                  />
                </Grid>

                {/* Phone - own line, full width */}
                <Grid item xs={12} sx={{ width: '100%', display: 'block' }}>
                  <Box sx={{ display: 'flex', gap: 0, alignItems: 'stretch', width: '100%' }}>
                    <Select
                      className="country-code-select"
                      classNamePrefix="country-code-select"
                      placeholder="Code"
                      isSearchable={true}
                      value={countryCodes.find(cc => cc.code === countryCode) || countryCodes.find(cc => cc.code === '+91')}
                      onChange={handleCountryCodeChange}
                      options={countryCodes}
                      getOptionLabel={(option) => option.code}
                      getOptionValue={(option) => option.code}
                      formatOptionLabel={(option) => (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <img
                            src={`https://flagcdn.com/w20/${option.country}.png`}
                            alt={option.name}
                            style={{ width: '20px', height: '15px', objectFit: 'cover', borderRadius: '2px' }}
                          />
                          <span>{option.code}</span>
                        </Box>
                      )}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          minHeight: '56px',
                          width: '160px',
                          minWidth: '160px',
                          border: '1px solid #E0E0E0',
                          borderRadius: '12px 0 0 12px',
                          borderRight: 'none',
                          boxShadow: state.isFocused ? '0 0 0 2px rgba(163, 209, 57, 0.25)' : 'none',
                          '&:hover': {
                            borderColor: '#A3D139'
                          }
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected ? '#1976d2' : state.isFocused ? '#f5f5f5' : 'white',
                          color: state.isSelected ? 'white' : '#333',
                          textAlign: 'left',
                          justifyContent: 'flex-start',
                          padding: '6px 5px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          '&:hover': {
                            backgroundColor: state.isSelected ? '#1976d2' : '#f0f0f0'
                          }
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                          marginTop: '4px',
                          minWidth: '200px'
                        }),
                        menuList: (provided) => ({
                          ...provided,
                          textAlign: 'left',
                          padding: '4px 0'
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: '#333',
                          textAlign: 'left',
                          fontSize: '14px'
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: '#999',
                          textAlign: 'left',
                          fontSize: '14px'
                        }),
                        noOptionsMessage: (provided) => ({
                          ...provided,
                          textAlign: 'left',
                          padding: '8px 12px',
                          fontSize: '14px'
                        }),
                        input: (provided) => ({
                          ...provided,
                          textAlign: 'left',
                          fontSize: '14px'
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          textAlign: 'left',
                          padding: '0 8px'
                        })
                      }}
                    />
                    <TextField
                      fullWidth
                      label="Phone Number"
                      type="tel"
                      inputProps={{ maxLength: 15 }}
                      required
                      variant="outlined"
                      placeholder="Enter phone number"
                      sx={{
                        ...inputSx,
                        flex: 1,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '0 12px 12px 0',
                          borderLeft: '1px solid #E0E0E0'
                        }
                      }}
                      value={formData.mobile}
                      onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // remove non-numbers
                      handleInputChange("mobile", value);
                    }}
                    />
                  </Box>
                </Grid>

                {/* Message - own line, full width; button sits below */}
                <Grid item xs={12} sx={{ width: '100%', display: 'block' }}>
                  <TextField
                    fullWidth
                    label="Write Message"
                    multiline
                    rows={4}
                    value={formData.message}
                    onChange={(e) => handleInputChange("message", e.target.value)}
                    sx={inputSx}
                  />
                </Grid>

                <Grid item xs={12} sx={{ width: '100%', display: 'block', mt: 1, textAlign: "center" }}>
                  <Button
                    type="submit"
                    size="small"
                    sx={{
                      py: 0.75,
                      px: 3,
                      fontSize: '0.875rem',
                      fontFamily: 'var(--default-font)',
                      textTransform: 'none',
                      color: '#ffffff',
                      border: '2px solid #9ca3af',
                      fontWeight: 600,
                      borderRadius: '8px',
                      background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)',
                      boxShadow: '0 2px 8px rgba(37, 99, 235, 0.3)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%)',
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 12px rgba(37, 99, 235, 0.4)'
                      },
                      '&:active': {
                        transform: 'translateY(0)'
                      }
                    }}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </Button>
                </Grid>
              </Grid>
            </form>
            <Typography variant="caption" sx={{ display: 'block', mt: 2, textAlign: "center", color: "#636E72" }}>
              By contacting us you agree to our <b>Terms of Service</b> and <b>Privacy Policy</b>.
            </Typography>
          </Grid>

        </Paper>
      </Container>
    </Box>
  );
};
export default Contact;